export const EMBASSIES = {
  "อเมริกา": ["🇺🇸 สถานทูตสหรัฐอเมริกา", "🇨🇦 สถานทูตแคนาดา", "🇲🇽 สถานทูตเม็กซิโก", "🇧🇷 สถานทูตบราซิล", "🇦🇷 สถานทูตอาร์เจนตินา", "🇨🇱 สถานทูตชิลี", "🇨🇴 สถานทูตโคลอมเบีย", "🇵🇪 สถานทูตเปรู"],
  "ยุโรป": [
    "🇬🇧 สถานทูตสหราชอาณาจักร", "🇩🇪 สถานทูตเยอรมนี", "🇫🇷 สถานทูตฝรั่งเศส",
    "🇮🇹 สถานทูตอิตาลี", "🇪🇸 สถานทูตสเปน", "🇵🇹 สถานทูตโปรตุเกส",
    "🇳🇱 สถานทูตเนเธอร์แลนด์", "🇧🇪 สถานทูตเบลเยียม", "🇨🇭 สถานทูตสวิตเซอร์แลนด์",
    "🇦🇹 สถานทูตออสเตรีย", "🇸🇪 สถานทูตสวีเดน", "🇳🇴 สถานทูตนอร์เวย์",
    "🇩🇰 สถานทูตเดนมาร์ก", "🇫🇮 สถานทูตฟินแลนด์", "🇵🇱 สถานทูตโปแลนด์",
    "🇨🇿 สถานทูตเช็กเกีย", "🇭🇺 สถานทูตฮังการี", "🇬🇷 สถานทูตกรีซ",
    "🇮🇪 สถานทูตไอร์แลนด์", "🇷🇺 สถานทูตรัสเซีย", "🇺🇦 สถานทูตยูเครน",
    "🇹🇷 สถานทูตตุรกี", "🇷🇴 สถานทูตโรมาเนีย", "🇧🇬 สถานทูตบัลแกเรีย",
  ],
  "เอเชีย": [
    "🇯🇵 สถานทูตญี่ปุ่น", "🇰🇷 สถานทูตเกาหลีใต้", "🇨🇳 สถานทูตจีน",
    "🇸🇬 สถานทูตสิงคโปร์", "🇲🇾 สถานทูตมาเลเซีย", "🇮🇩 สถานทูตอินโดนีเซีย",
    "🇵🇭 สถานทูตฟิลิปปินส์", "🇻🇳 สถานทูตเวียดนาม", "🇮🇳 สถานทูตอินเดีย",
    "🇵🇰 สถานทูตปากีสถาน", "🇧🇩 สถานทูตบังกลาเทศ", "🇱🇰 สถานทูตศรีลังกา",
    "🇲🇲 สถานทูตเมียนมา", "🇰🇭 สถานทูตกัมพูชา", "🇱🇦 สถานทูตลาว",
    "🇳🇵 สถานทูตเนปาล", "🇲🇳 สถานทูตมองโกเลีย", "🇰🇿 สถานทูตคาซัคสถาน",
  ],
  "โอเชียเนีย": ["🇦🇺 สถานทูตออสเตรเลีย", "🇳🇿 สถานทูตนิวซีแลนด์"],
  "ตะวันออกกลาง & แอฟริกา": [
    "🇦🇪 สถานทูต UAE", "🇸🇦 สถานทูตซาอุดีอาระเบีย", "🇶🇦 สถานทูตกาตาร์",
    "🇰🇼 สถานทูตคูเวต", "🇴🇲 สถานทูตโอมาน", "🇧🇭 สถานทูตบาห์เรน",
    "🇮🇱 สถานทูตอิสราเอล", "🇯🇴 สถานทูตจอร์แดน", "🇮🇷 สถานทูตอิหร่าน",
    "🇪🇬 สถานทูตอียิปต์", "🇿🇦 สถานทูตแอฟริกาใต้", "🇲🇦 สถานทูตโมร็อกโก",
    "🇰🇪 สถานทูตเคนยา", "🇳🇬 สถานทูตไนจีเรีย",
  ],
} as const;
